<template>
  <div class="appointDetail">
    <div class="allHeader">
      <div class="header-H">
        <van-icon name="arrow-left" color="#fff" class="vanIcon" @click="returnIndex" />
        <span class="addInfo">预约详情</span>
      </div>
      <div class="projectName">
        <div class="nameFlex">
          <!-- // 0待完成1已完成2已取消 -->
          <div class="detailName">{{form.projectName}}</div>
          <div class="schedule" v-if="form.operationStatus==2">已完成</div>
          <div class="cancel" v-if="form.operationStatus==1">已取消</div>
          <div class="toBeFinish" v-if="form.operationStatus==3">待完成</div>
        </div>
        <div class="nextImg">
          <div>
            <div class="user_name">
              <van-icon name="user-circle-o" color="#fff" /> <span class="schedule_name">{{form.customerName}}</span>
            </div>
            <div class="user_name">
              <van-icon name="clock-o" color="#fff" /><span class="schedule_name">{{form.appointmentTime}}</span>
            </div>
          </div>
          <div class="vipImg">
            <img v-if="form.appointStatus=='VIP'" src="../../assets/img/vipVisit.png" alt="">
            <img v-if="form.appointStatus=='初诊'" src="../../assets/img/visit.png" alt="">
            <img v-if="form.appointStatus=='复诊'" src="../../assets/img/secondVisit.png" alt="">
          </div>
        </div>
      </div>
    </div>
    <div class="content">
      <van-cell-group>
        <van-cell title="预约号" :value="form.appointmentId" />
        <van-cell v-if="form.userId==empId" title="联系方式" :value="form.mobile" />
        <span v-if="form.mobile">
          <van-cell v-if="form.userId!=empId" title="联系方式" :value="form.mobile.replace(form.mobile.substr(3,4), '****')" />
        </span>
        <van-cell title="仪器使用时间">
          <div v-if="form.instrumentTime" class="showOverTooltip">
            <div v-for="(item,index) in form.instrumentTime.split(',')" :key="index">
              <span>{{item}}</span>
            </div>
          </div>
        </van-cell>
        <van-cell title="操作人" :value="form.doctorName" />
        <van-cell title="客户姓名" :value="form.customerName" />
        <van-cell title="备注" :value="form.remark" />
        <!-- <van-cell title="预约提交时间" :value="form.createTime" /> -->
        <van-cell title="完成时间" :value="form.completionTime" v-if="form.operationStatus==2" />
        <van-cell title="取消时间" :value="form.completionTime" v-if="form.operationStatus==1" />
      </van-cell-group>
    </div>
    <div class="addProject" @click="copyProject(form)" v-if="form.projectType!=''&&form.projectType!=null">复制项目</div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      form: {},
      userStatus: '',
      empId: "",
    }
  },
  created() {
    this.form = this.$route.query
    this.userStatus = JSON.parse(localStorage.getItem('userInfo')).status
    this.empId = JSON.parse(localStorage.getItem('userInfo')).empId
    console.log(this.empId)
  },
  methods: {
    // 添加预约返回首页
    returnIndex() {
      this.$router.push("/index");
      // this.$router.go(-1);
    },
    copyProject(row) {
      this.$router.push({
        name: "copyAppointment",
        query: row,
      });
    }
  },

}

</script>
<style scoped>
@import "../../assets/css/appointDetail.css";

.vanIcon {
  position: absolute;
  left: 1.3rem;
}

.vipImg img {
  width: 2.5rem;
  margin-top: 0.6rem;
}

.addProject {
  width: 94%;
  height: 2.5rem;
  margin: 0.5rem auto;
  background: linear-gradient(118deg, #0297ce 0%, #0164a8 100%);
  border-radius: 6px;
  text-align: center;
  line-height: 2.5rem;
  font-size: 1rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #ffffff;
  margin-bottom: 0.38rem;
}
</style>



// WEBPACK FOOTER //
// src/components/page/appointDetail.vue